import { Permission } from '@server/permissions';
import { GetStartedDto } from '../components/pages/get-started/getStartedTypes';
import { AccountOnboardingStep } from '@server/account-onboarding';
import { PlanFeature } from '@server/plan';
import { AccountType } from '@server/account-type';
import { QuestionnaireDto } from '../components/pages/questionnaire/questionnaireTypes';
import { UserPreferencesTableColumnSettings } from '@server/user-preferences';

export type Emoji = {
  content: string;
  bgColor: string;
};

export enum InviteeStatus {
  InviteeStatusPending = 'PENDING',
  InviteeStatusExpired = 'EXPIRED',
}

export enum Template {
  Funnel = 'FUNNEL',
  Account = 'ACCOUNT',
}

export interface InviteeInfo {
  invitee: string;
  roleGroupId: string;
  status: InviteeStatus;
  template: Template;
  message?: string;
  entryPointName?: string;
  entryPointId?: string;
}

export interface UserPreferences {
  getStarted?: GetStartedDto;
  defaultCreationCrmOrgId?: string | null;
  questionnaire?: QuestionnaireDto;
  freeAiQuestionsCount?: number;
  tableColumnSettings?: UserPreferencesTableColumnSettings[];
}

export interface UserInfo {
  id?: string;
  canResetPassword?: boolean;
  name?: string;
  imageUrl?: string;
  jobTitle?: string;
  email?: string;
  account?: {
    id?: string;
    name?: string;
    authZeroOrgId?: string;
    onboardingStep?: AccountOnboardingStep;
    type?: AccountType;
    trialStartDate?: string;
    trialEndDate?: string;
    disableAi?: boolean;
    isLoginHistoryEnabled?: boolean;
    planFeatures?: PlanFeature[];
    isBuildModeEnabled?: boolean;
  };
  roleGroupId?: string;
  emoji?: Emoji;
  orgPermissions?: Record<string, Permission[]>;
  accountPermissions?: Permission[];
  status?: UserStatus;
  preferences?: UserPreferences;
  mcpOrgId?: string;
}

export enum UserStatus {
  Inactive = 'INACTIVE',
  Active = 'ACTIVE',
}

export interface AccountUsersData {
  invitations?: InviteeInfo[];
  users?: UserInfo[];
}

export type ClearbitEnrichment = {
  person: Record<string, any>;
  company: Record<string, any>;
};
